import React from 'react';
import Switch from 'react-switch';
import { Label, WarmupToggleWrapper } from './WarmupToggleStyles';

interface IProps {
  shouldDisplayWarmups: boolean;
  shouldDisplayWarmupsCallback: (checked: boolean) => void;
  disabled: boolean;
}

export const WarmupToggle: React.FC<IProps> = (props) => {
  const { shouldDisplayWarmups, shouldDisplayWarmupsCallback, disabled } = props;
  return (
    <WarmupToggleWrapper>
      <Label>Show warmups</Label>
      <Switch
        checked={shouldDisplayWarmups}
        onChange={(checked: boolean) => shouldDisplayWarmupsCallback(checked)}
        onColor='#ec691a'
        checkedIcon={false}
        uncheckedIcon={false}
        height={24.8}
        width={40.8}
        disabled={disabled}
      />
    </WarmupToggleWrapper>
  );
};
